/**
 * Created by fernando.garcia on 2/08/19.
 */

/**
 * Valida los datos de un objeto completo de reglas de un template
 * Ejemplo de objeto:
 * {
 *  "id": "1",
 *  "rules": "{"rules":[{"name":"related_purchase_id","operator":"equal","values":[true]}]}",
 *  "description": "Mi descripcion",
 *  "templateId": "4",
 *  "enabled": "1"
 * }
 *
 * @param rulesSet Objeto de reglas
 * @returns {Array}
 */
const validate = function (rulesSet) {
    let errorMessages = [];

    if (!rulesSet.templateId) {
        errorMessages.push("Es necesario seleccionar un template.");
    }

    if (!rulesSet.rules) {
        errorMessages.push("Es necesario configurar alguna regla.");
    } else {
        let rulesObj = JSON.parse(rulesSet.rules);
        if (!rulesObj.rules || !rulesObj.rules.length) {
            errorMessages.push("Es necesario configurar alguna regla.");
        }
    }
    return errorMessages;
}

export default {
    validate
};
